

import XLSX from 'xlsx'
const initCols = [{ wpx: 100 }, { wpx: 100 }, { wpx: 200 }, { wpx: 80 }, { wpx: 150 }, { wpx: 100 }, { wpx: 300 }, { wpx: 300 }]
function exportExcel (headers, data, fileName = '表格', cols = initCols) {
  fileName = `${fileName}.xlsx`
  let _headers = headers
    .map((item, i) => {
      const o = { key: item.key, title: item.title, position: String.fromCharCode(65 + i) + 1 }
      return o
    })
  
  _headers = _headers.reduce((prev, next) => {
    return { ...prev, ...{[next.position]: { key: next.key, v: next.title } } }
  }, {}) // 累加
  
  let _data = data
    .map((item, i)=>{
      return headers.map((key, j)=>{
        return { content: item[key.key], position: String.fromCharCode(65 + j) + (i + 2)}
      })
    })
  // 对刚才的结果进行降维处理（二维数组变成一维数组）
  _data = _data.reduce((prev, next) => prev.concat(next))
  // 转换成 worksheet 需要的结构
  _data = _data.reduce((prev, next) => {
    return {...prev, ...{ [next.position]: { v: next.content } }}
  }, {})
  
  // 合并 headers 和 data
  
  const output = {..._headers, ..._data}
  // 获取所有单元格的位置
  const outputPos = Object.keys(output)
  // 计算出范围 ,["A1",..., "H2"]
  const ref = `${outputPos[0]}:${outputPos[outputPos.length - 1]}`
  // 构建 workbook 对象
  const wb = {
    SheetNames: ['mySheet'],
    Sheets: {
      mySheet: {
        ...output,
        '!ref': ref,
        '!cols': cols, 
      },
    },
  }

  // 导出 Excel
  XLSX.writeFile(wb, fileName)
}
export default exportExcel
